//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sortBy } from 'lodash-es';
import TheFooter from '@/components/layout/the-footer.vue';
import fractionToDecimal from '~/utils/fraction-to-decimal';
export default {
  components: {
    TheFooter,
  },
  data() {
    return {
      drawer: false,
      items: [],
    };
  },
  async fetch() {
    const items = (await this.$content('pages').fetch()).map((item) => ({
      ...item,
      pos: fractionToDecimal(item.pos),
    }));
    this.items = sortBy(items, ['show_tab', 'pos']);
  },
  fetchKey: 'layout/default',
  head() {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true });
    const { href: canonical } = i18nHead.link.find(
      ({ hid }) => hid === 'i18n-can',
    );
    return {
      htmlAttrs: {
        itemscope: '',
        itemtype: 'https://schema.org/WebPage',
        ...i18nHead.htmlAttrs,
      },
      meta: [
        ...i18nHead.meta,
        {
          hid: 'og:url',
          name: 'og:url',
          property: 'og:url',
          content: canonical,
        },
      ],
      link: [...i18nHead.link],
    };
  },
  mounted() {
    const beforePrint = function () {
      console.log('Functionality to run before printing.');
      this.drawer = false;
    };
    const afterPrint = function () {
      console.log('Functionality to run after printing');
    };
    if (window.matchMedia) {
      const mediaQueryList = window.matchMedia('print');
      mediaQueryList.addListener(function (mql) {
        if (mql.matches) {
          beforePrint();
        } else {
          afterPrint();
        }
      });
    }
    window.onbeforeprint = beforePrint;
    window.onafterprint = afterPrint;
  },
};
